import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { PortalContextService } from "@/core/services/portal-context.service";
import { GlobalEnumerationsAceXfoundportalobjekt } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enumerations-ace-xfoundportalobjekt";

@Injectable({
    providedIn: 'root'
})
export class AnfrageScopeHttpInterceptor implements HttpInterceptor {
    
    protected oldScope: GlobalEnumerationsAceXfoundportalobjekt;

    constructor(protected portalContextService: PortalContextService) { }
    
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //If there is no current scope based on the url, because the user leaves the anfrage, just take the cached old scope
        const scopeType = this.portalContextService.CurrentItemContext?.type ?? this.oldScope;

        if (scopeType && !req.headers.has('x-anfragescope')) {
            this.oldScope = scopeType;
            req = this.setGlobalEnumerationsAceXfoundportalobjektHeader(req, scopeType);
        }
        
        return next.handle(req);
    }

    protected setGlobalEnumerationsAceXfoundportalobjektHeader(request: HttpRequest<any>, scope: GlobalEnumerationsAceXfoundportalobjekt) {
        return request.clone({
            setHeaders: {
                'x-anfragescope': `${scope}`
            }
        });
    }
}